<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre style="margin-top: 0px; margin-bottom: 10px; font-family: 'Montserrat', sans-serif; font-size: 40px; font-weight:900; text-align: center; text-transform: uppercase;">Pago Sobrequipaje</pre>
          <table style="border-collapse: collapse; width: 100%; font-size: 32px; text-align: left;">  
            <tr>    
              <td style="padding: 2px; font-weight:700;">No PASE:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.boleto_id }}</td>  
            </tr> 
            <tr>    
              <td style="padding: 2px; font-weight:700;">CANTIDAD:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ cantidad }}</td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:700;">Monto:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ monto }}</td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:700;">PAGO:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.resumen_pago }}</td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:700;">FECHA:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.created_at | moment('DD - MM - YYYY hh:mm') }}</td>  
            </tr>
          </table>
          <p style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">
            {{user.username}}/{{Date.now()  | moment('DDMMYYYY')}}/{{ Date.now()  | moment('HH:mm') }} 
          </p>
        </body>
      </html>
</template>
<script>
export default {
  props: {
    boleto: {required: false},
    user: {required: false},
    cantidad: {required: false},
    monto: {required: false},
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
}
</script>
<style scoped> 
</style>